var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('phone-input',{attrs:{"variant":"primary","messages":_vm.messages,"label":_vm.$t('question.phone'),"error":_vm.manualError},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }